import { useEffect } from 'react';
import { sanitizeUri } from 'micromark-util-sanitize-uri';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
import useQueryParams from 'src/hooks/useQueryParams';
const TRUSTED_REDIRECT_HOSTS = ['checkout.stripe.com'];
const isTrustedRedirectUrl = (urlStr: string) => {
  const url = new URL(urlStr);
  return url.protocol === 'https:' && TRUSTED_REDIRECT_HOSTS.includes(url.host);
};
const AppExternalPaymentRedirectView = () => {
  const {
    redirectUrl
  } = useQueryParams<{
    redirectUrl: string;
  }>() || {};
  useEffect(() => {
    if (redirectUrl && isTrustedRedirectUrl(redirectUrl)) {
      /**
       * 외부 결제 세션 URL에 hash가 포함되는 경우가 있는데 이것이 query parameter가 아니라 현 주소 hash로 인식됨
       * 의도된 전체 url로 이동하기 위해 임의로 hash 조합 필요
       */
      window.location.href = sanitizeUri(redirectUrl + window.location.hash);
    }
  }, [redirectUrl]);
  return null;
};
export default withWebClientValidation(AppExternalPaymentRedirectView);